import { render, staticRenderFns } from "./WelfareCentreMap.vue?vue&type=template&id=7782330e&"
import script from "./WelfareCentreMap.vue?vue&type=script&lang=js&"
export * from "./WelfareCentreMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports